import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAdmin = loadable(() => import(/* webpackChunkName: "content/admin" */ './Admin'));
